import React from 'react';
import Gallery from '../components/Gallery';
import { podcastImages } from '../data/images';

const Podcast = () => {
  return (
    <div className="gallery-page">
      <section 
        className="hero-half"
        style={{
          backgroundImage: `url('/images/dvi-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1>Podcast Production</h1>
          <p>
            Professional podcast recording and production services with high-quality audio and video capabilities. 
            From studio setup to post-production, we deliver exceptional podcast content.
          </p>
        </div>
      </section>
      
      <section className="gallery-section">
        <div className="container">
          <Gallery images={podcastImages} sectionId="podcast" />
        </div>
      </section>

    </div>
  );
};

export default Podcast;
